export const environment = {
  production: false,
  dev: true,

  baseUrl: 'https://dev-halo8.halobizapps.com/api/v1/',
  // baseUrl: 'https://dev-halobiznew.halobizapps.com/api/v1/',

  baseUrlV2: 'https://dev-halo8.halobizapps.com/api/v2/',
  // baseUrlV2: 'https://dev-halobiznew.halobizapps.com/api/v2/',
  baseUrlV21: 'https://localhost:7175/api/',

  baseMailUrl: 'https://dev-mail.halobizapps.com/Mail/',
  // baseMailUrl: 'https://dev-halobizmail.halobizapps.com/Mail/',
  // gmaBaseUrl: 'https://dev-gmanew.halobizapps.com/api/v1/',
  gmaBaseUrl: 'https://dev-gma.halobizapps.com/api/v1/',
  // gmaBaseUrl: 'http://10.0.4.153:8050/api/v1/',
  reportUrl: 'https://report.halobizapps.com/Reports/',
  onlineBackendBaseUrl: 'https://dev-online.halobizapps.com/api/v1/',
  onlineBackendBaseUrl_: 'https://dev-online.halobizapps.com/api/',
  liabilityControlAccountId: '1200000000', //Assets::Receivable
  assetControlAccountId: '5100000000', //Expenses::PayrollAccount
  expenseControlAccountId: '1300000000', //Specific Control Account To Be Created
  defaultImage: '/assets/layout/images/users-vector.jpg',
  defaultServiceImage:
    'https://firebasestorage.googleapis.com/v0/b/halo-biz.appspot.com/o/serviceImage%2FGuard.png?alt=media&token=2c6c2279-5508-4d8a-8169-a468595bb2f6',
  SecuGenLicenseKey:
    'M528REZ19U7bubYGRmmLN086ga1gO9cN+BC9umwnmxv9ssmfu0tDq4S1z9s6JgVO',
  AssetAccounClassId: 1,
  AssetControlAccountReceivableId: 2,
  reportViewerHost:
    'https://reportserver.northeurope.cloudapp.azure.com/reports/report/',
  customInvoices: [
    { contractId: 1896, category: 'nestle' },
    { contractId: 2017, category: 'nestle' },
    { contractId: 2022, category: 'nestle' },
  ],
};
